// extracted by mini-css-extract-plugin
module.exports = {"reportsRadio":"_1-ku-"};